const fallbackImageHandler = (event) => {
  event.target.src = '/fallback.png';
  //event.target.parentElement.style.display = "none";
};

export default fallbackImageHandler;